import { all, call, delay, put, select, takeLatest } from "redux-saga/effects";
import {
  checkAiCreatorPermission,
  getGeneratedImagesService,
  getMediaKitImagesService,
  getMediaKitReportAdminService,
} from "../../../service/aiCreator.service";
import {
  getGeneratedImagesFailure,
  getGeneratedImagesSuccess,
  getMediaKitImagesFailure,
  getMediaKitImagesSuccess,
  getMediaKitReportAdminFailure,
  getMediaKitReportAdminSuccess,
  getUserHasAccessFailure,
  getUserHasAccessSuccess,
  ResetCreatorAISuccess,
} from "./actions";

function* getUserHasAccess() {
  const selectedToken = (state) => state.auth.token;
  const selectedContract = (state) => state.initialSettings.contract;
  const selectedEvent = (state) => state.initialSettings.event;

  try {
    const token = yield select(selectedToken);
    const opportunityId = yield select(selectedContract);
    const eventId = yield select(selectedEvent);

    const response = yield call(checkAiCreatorPermission, {
      token,
      eventId: eventId.value,
      opportunityId: opportunityId.value,
    });

    if (response.status !== 200)
      throw new Error("Failed to get if user has access");

    const { data } = response;
    const { canCreateMidiaKit, whatsappIa: whatsapp, unlimitedImages } = data;

    yield put(
      getUserHasAccessSuccess({
        hasAccess: canCreateMidiaKit,
        whatsapp,
        unlimitedImages,
      }),
    );
  } catch (error) {
    yield put(getUserHasAccessFailure(error));
  }
}

function* getGeneratedImages() {
  const selectedToken = (state) => state.auth.token;
  const selectedContract = (state) => state.initialSettings.contract;

  try {
    const token = yield select(selectedToken);
    const opportunityId = yield select(selectedContract);
    const response = yield call(getGeneratedImagesService, {
      token,
      opportunityId: opportunityId.value,
    });

    if (response.status !== 200)
      throw new Error("Failed to get generatedImages");

    const { data } = response;

    yield put(
      getGeneratedImagesSuccess({
        generatedImages: data.urls,
        remainingAttempts: data.remainingAttempts,
      }),
    );
  } catch (error) {
    yield put(getGeneratedImagesFailure(error));
  }
}

function* getMediaKitImages() {
  const selectedToken = (state) => state.auth.token;
  const selectedContract = (state) => state.initialSettings.contract;

  try {
    const token = yield select(selectedToken);
    const opportunityId = yield select(selectedContract);
    const response = yield call(getMediaKitImagesService, {
      token,
      opportunityId: opportunityId.value,
    });

    if (response.status !== 200)
      throw new Error("Failed to get generatedImages");

    const { data } = response;
    const { imageSquareUrl, imageVerticalUrl, imageHorizontalUrl } = data;

    const verify = imageSquareUrl && imageHorizontalUrl && imageVerticalUrl;

    yield put(
      getMediaKitImagesSuccess({
        dataUrls: verify
          ? [imageSquareUrl, imageVerticalUrl, imageHorizontalUrl].filter(
              (i) => i,
            )
          : [],
      }),
    );
  } catch (error) {
    yield put(getMediaKitImagesFailure({ error }));
  }
}

function* getMediaKitReportAdmin({ payload }) {
  const selectedToken = (state) => state.auth.token;

  try {
    const token = yield select(selectedToken);
    const { year, eventId, search, page, per_page, sortBy, order, status } =
      payload;
    const response = yield call(getMediaKitReportAdminService, {
      token,
      year,
      eventId,
      search,
      page,
      per_page,
      sortBy,
      order,
      status,
    });
    const { data } = response;

    yield put(
      getMediaKitReportAdminSuccess({
        data: data.opportunityMediaKits,
        pageInfo: data.paginationInfo,
      }),
    );
  } catch (error) {
    yield put(getMediaKitReportAdminFailure({ error }));
  }
}

function* ResetCreatorAI() {
  yield delay(350);
  yield put(ResetCreatorAISuccess());
}

export default all([
  takeLatest("AI_CREATOR_ACCESS", getUserHasAccess),
  takeLatest("AI_CREATOR_GET_GENERATED_IMAGES", getGeneratedImages),
  takeLatest("GET_MEDIA_KIT", getMediaKitImages),
  takeLatest("GET_MEDIA_KIT_REPORT", getMediaKitReportAdmin),
  takeLatest("RESET_CREATOR_AI", ResetCreatorAI),
]);
